<script lang="ts">
  export let images: string[] = [];
  export let title: string = "";
  export let borderRadius: string = "16px";
  
  const [primary_img, secondary_img] = images || [];
</script>

<div class="image-title">
  {#if images.length > 0}
    <picture>
      <source srcset={primary_img} media="(min-width: 992px)" />
      <img
        class="news-own-content-banner"
        alt={title}
        style="border-radius: {borderRadius}"
        src={secondary_img || primary_img} />
    </picture>
  {:else}
    <div class="image-fallback" style="border-radius: {borderRadius}">
      <span>{title?.charAt(0).toUpperCase() || ""}</span>
    </div>
  {/if}
</div>

<style lang="scss">
  .image-title {
    align-items: center;
    width: 100%;
  }

  picture,
  img {
    // Image max dimensions are already pre-set in the Manage Portal
    width: 100%;
    object-fit: cover;
    object-position: center center;
  }

  .image-fallback {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    
    span {
      font-size: 5rem;
      font-weight: 600;
      color: #333;
      text-transform: uppercase;
      opacity: 0.7;
    }
  }
</style> 